import fetch from "auth/FetchInterceptor"

const BlogService = {
  // Create a new blog article
  create: (data) => {
    return fetch({
      data,
      method: "post",
      url: "/blog/articles/",
    })
  },

  // Delete a blog article
  deleteById: (id) => {
    return fetch({
      method: "delete",
      url: `/blog/articles/${id}`,
    })
  },

  // Get all blogs (paginated)
  getAll: (page = 1) => {
    return fetch({
      method: "get",
      url: `/blog/articles/?page=${page}`,
    })
  },

  // Get a single blog by ID
  getById: (id) => {
    return fetch({
      method: "get",
      url: `/blog/articles/${id}`,
    })
  },

  // Search blogs by title
  search: (page = 1, title) => {
    let url = `/blog/articles/?page=${page}`
    if (title) {
      url += `&title=${encodeURIComponent(title)}`
    }
    return fetch({
      method: "get",
      url,
    })
  },

  // Update a blog article
  update: (id, data) => {
    return fetch({
      data,
      method: "put",
      url: `/blog/articles/${id}`,
    })
  },
}

export default BlogService
